"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var FormError = function (_a) {
    var errors = _a.errors;
    var errs = Array.isArray(errors) ? errors : [errors];
    return errors && errors.length > 0 ? (react_1.default.createElement("div", { "data-dusk": "form-input-errors", className: "form-errors" }, errs.map(function (error, index) { return (react_1.default.createElement("p", { key: index, className: "mt-1 mb-0 text-red text-xs" }, error)); }))) : null;
};
exports.default = FormError;
//# sourceMappingURL=index.js.map